import { Component, Input, OnInit } from '@angular/core';
import { environment }              from '../../../environments/environment';
import { BankCustomizationData }    from '../../api/session/session.service';

@Component({
  selector: 'pin-bank-footer-logo',
  templateUrl: './bank-footer-logo.component.html'
})
export class BankFooterLogoComponent implements OnInit {

  @Input()
  bankCustomizationData: BankCustomizationData;

  footerCopyrightAndDisclaimerMessage: string;

  isLogoValid = true;

  ngOnInit(): void {
    this.footerCopyrightAndDisclaimerMessage = this.bankCustomizationData.footerCopyrightAndDisclaimerMessage;
    this.footerCopyrightAndDisclaimerMessage = this.footerCopyrightAndDisclaimerMessage.replace(/(<a)\s+(href=.+?>)/g, "$1 class='dcp-link' $2");
  }

  getFooterLogoUrl(): string {
    const footerLogoFileName = this.bankCustomizationData?.footerLogoFileName;
    return footerLogoFileName
      ? `${environment.institutionFooterLogoUrl}/${encodeURIComponent(footerLogoFileName)}`
      : '';
  }

  setFooterLogoInvalid(): void {
    this.isLogoValid = false;
  }

}
